import api from '@/js/services/api';
export default {
    addNewUniformItem(title) {
        return api().post(`/master-admin/uniforms/add`, {title})
    },

    delete(id) {
        return api().delete(`/master-admin/uniforms/` + id + `/delete`);
    },

    deleteRequest(id) {
        return api().delete(`/master-admin/uniforms/requests/${id}/delete`);
    },

    deleteReturnedUniformRequest(returnedUniformId) {
        return api().delete(`/master-admin/uniforms/requests/returned/${returnedUniformId}/delete`);
    },

    deleteRequestByApplicant(requestId) {
        return api().delete(`/applicant/uniform/request/${requestId}/delete`);
    },

    getRequestInfo(id) {
        return api().get(`/master-admin/uniforms/requests/${id}/get`)
    },

    getRequestsList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/uniforms/requests/get?' + searchParams.toString())
    },

    getEmployeeListOfRequests(applicantId, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/master-admin/${applicantId}/uniform/requests/get?` + searchParams.toString())
    },

    getReturnedUniforms(id) {
        return api().get(`/master-admin/applicants/${id}/uniforms/returned/get`)
    },

    getHistory(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/uniforms/history/get?' + searchParams.toString())
    },

    getStatusList() {
        return api().get(`/master-admin/uniforms/requests/statuses/get`)
    },

    getUniformsList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/uniforms/get?' + searchParams.toString())
    },

    searchUniformInList(search) {
        return api().get('/master-admin/uniforms/get', {
            params: {
                search: search,
                withoutPagination: true,
                sortBy: 'title',
                sortDir: 'asc'
            }
        });
    },


    sendNewRequest(request) {
        return api().post(`/master-admin/uniforms/requests/store`, {request})
    },
    sendReturnedUniform(request) {
        return api().post(`/master-admin/uniforms/requests/return`, {request})
    },

    updateRequestStatus(request_id, status_id) {
        return api().put(`/master-admin/uniforms/requests/${request_id}/update`, {status_id})
    },

    updateRequestItem(request_id, request) {
        return api().put(`/master-admin/uniforms/requests/${request_id}/update`, request)
    },

    updateUniformItem(id, title) {
        return api().put(`/master-admin/uniforms/${id}/update`, {title})
    },



}
